var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['change-language-link', { 
		iconLangClass: _vm.hasIcon,
		'has-icon': _vm.hasIcon, 
		'loading': _vm.loading
	}],attrs:{"href":_vm.path},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.updateLanguage($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateLanguage($event)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }